const path = require('path')

module.exports = {
  publicPath: '/termine',
  transpileDependencies: ['@oeamtc/oeamtc-oidc-js-lib', 'mapbox-gl', '@oeamtc/styleguide-vuejs-lib-ui'],

  chainWebpack(config) {
    'use strict'

    // config.resolve.alias

    /**
     * Disable prefetch a we only want to have a single entry point file
     */
    config.plugins.delete('prefetch')
    config.plugins.delete('preload')

    config.resolve.alias
      .set('@', path.resolve(__dirname, 'src'))
      .set('styles', path.resolve(__dirname, 'src/styles'))

    config.module
      .rule('vue')
      .use('vue-loader')
      .tap(() => ({
        compilerOptions: {
          isCustomElement: (tag) => tag.startsWith('oeamtc-'),
        },
      }))

    if (process.env.NODE_ENV === 'production') {
      config.plugin('html').tap(([options]) => [
        {
          ...options,
          filename: path.resolve(__dirname, 'dist/templates/index.html'),
        },
      ])
      config.module
        .rule('html')
        .test(/\.html$/)
        .use('raw-loader')
        .loader('raw-loader')
    }
  },
  devServer: {
    https: true,
    // host: "dev.oeamtc.at",
    port: 8080,
    disableHostCheck: true,
    liveReload: true,
    proxy: {
      '/api/moe/1.0': {
        target: 'https://webint.oeamtc.at',
        changeOrigin: true,
      },
      '/mein-oeamtc/login': {
        target: 'https://webint.oeamtc.at',
        changeOrigin: true,
        bypass: (request, response) => {
          console.info('moe-login', request, response)
        },
      },
      '^/termine/auth': {
        target: 'https://webint.oeamtc.at',
        changeOrigin: true, // to change origin
        secure: true, // to keep http-only cookies
        // forward to https://webint.oeamtc.at/termine/auth/token
        // or forward to https://webint.oeamtc.at/api/moe/1.0/auth/oauth2/token
        // pathRewrite: { '^/termine/auth/token': '/api/moe/1.0/auth/oauth2/token' },
        onProxyReq: (proxyReq) => {
          console.info(proxyReq.method, ' ', proxyReq.path, ' onProxyReq: change origin')
          proxyReq.setHeader('origin', 'https://webint.oeamtc.at')
          console.info('kkkk', proxyReq)
          //proxyReq.headers['origin'] = 'https://webint.oeamtc.at';
        },
        onProxyRes: (proxyRes) => {
          console.info(proxyRes.method, ' ', proxyRes.path, ' onProxyRes: change origin back')
          proxyRes.headers['origin'] = 'https://localhost:8080'
        },
      },
      '/mein-oeamtc/login-verifizieren': {
        target: 'https://webint.oeamtc.at',
        changeOrigin: true,
        bypass: (request, response) => {
          console.info('moe-login-verifizieren', request, response)
        },
      },
      // '/mein-oeamtc/login2': {
      //   target: 'https://www.foobar.com',
      //   changeOrigin: true,
      //   followRedirects: false,
      //
      //   //onProxyReq: proxyReq => {
      //    // console.info("kkkk", proxyReq);
      //   //},
      //   onProxyRes: function(proxyRes, req, res) {
      //     console.info("req ", req.path)
      //     console.info("res ", res)
      //   //  console.log('RAW Response from the target',JSON.stringify(proxyRes.headers, true, 2));
      //
      //     let local_url = "https://localhost:8080"
      //     let redirect_uri = local_url + '/mein-oeamtc/login-verifizieren?redirect=https://localhost:8080/foobar'
      //     let client_id = "awSu8gF25u_wURew6tTH31P6Ltka"
      //     let target_url = 'https://loginint.oeamtc.at/auth/authorize?response_type=code&client_id=' + client_id + '&scope=openid+email&redirect_uri=' + redirect_uri;
      //
      //      target_url = 'https://webint.oeamtc.at/mein-oeamtc/login?redirect='+local_url+'/termine'
      //
      //     const result = {
      //       my_cookie: "", // req.cookies['foo'], // get cookie
      //     }
      //
      //     res.setHeader('Location', target_url)
      //     res.writeHead(301, {
      //       'Content-Type': 'application/json',
      //       'Location': target_url
      //     });
      //     res.end(JSON.stringify(result));
      //
      //
      //   },
      //   onProxyReq: proxyReq => {
      //     console.info("path", proxyReq.path);
      //     //path: '/_external/hf-assets/v1/js',
      //     //method: 'GET',
      //     // Browers may send Origin headers even with same-origin
      //     // requests. To prevent CORS issues, we have to change
      //     // the Origin to match the target URL.
      //     if (proxyReq.getHeader('origin')) {
      //       proxyReq.setHeader('origin', 'asdasd');
      //     }
      //   }
      //   // logLevel: 'debug' /*optional*/
      // },
      '/termine/_external/web-header-api': {
        target: 'https://webint.oeamtc.at',
        pathRewrite: { '^/termine/_external': '' },
        changeOrigin: true,
      },
      '/header-components': {
        target: 'https://webint.oeamtc.at',
        changeOrigin: true,
      },
      '/mein-oeamtc': {
        target: 'https://webint.oeamtc.at',
        changeOrigin: true,
      },
      '/api/moe/1.0/login': {
        target: 'https://webint.oeamtc.at',
        changeOrigin: true,
      },
      '/selfservice/ext': {
        target: 'https://webint.oeamtc.at',
        changeOrigin: true,
      },
      '^/termine/api': {
        target: 'https://webint.oeamtc.at',
        changeOrigin: true,
        secure: false,
        pathRewrite: {
          '^/termine/api': '/termine/api',
        },
        headers: {
          Connection: 'keep-alive',
        },
      },
      '/termine/login/sessions': {
        target: 'https://loginint.oeamtc.at/legacy/api/identity/v1/sessions/',
        changeOrigin: true,
      },
    },
  },
  configureWebpack: {
    output: {
      jsonpFunction: 'tvgJsonp',
    },
    optimization: {
      // minimize: false,
      splitChunks: {
        /**
         * This reduces the initial output to one file (browser entrypoint,
         * bootstrapper) named 'app.js', it will load all other assets
         */
        maxInitialRequests: 1,
      },
    },
    resolve: {
      extensions: ['.js', '.vue', '.json', '.scss'],
      alias: {
        styles: path.resolve(__dirname, 'src/assets/styles'),
      },
    },
  },
  css: {
    // Enable CSS source maps.
    // sourceMap: true,
    loaderOptions: {
      scss: {
        additionalData: `@import "~@/assets/styles/_definitions.scss";`,
      },
    },
  },
}
